var togglingConcierge = false;
var togglingExpress = true;

export const featureTogglingConfig = {
    environment: {
        concierge: togglingConcierge,
        express: togglingExpress
    },

    admin: {
        pages: {
            'zones': {
                active: true,
                concierge: togglingConcierge,
            },
            'price-list': {
                active: true,
                concierge: togglingConcierge,
            },
            'create-order': {
                active: true,
                concierge: togglingConcierge,
            },
            'bulk-uploading': {
                active: true,
                concierge: togglingConcierge,
            },
            'user-profile': {
                active: true,
                concierge: togglingConcierge,
                express: togglingExpress,
               

            },
            'bulkOrder': {
                active: true,
                concierge: togglingConcierge,

            },
            'maps': {
                active: true,
                concierge: togglingConcierge,
            },
            'notifications': {
                active: true,
                concierge: togglingConcierge,
            },
            'distributor': {
                active: true,
                concierge: togglingConcierge,
            },
            'customer': {
                active: true,
                concierge: togglingConcierge,
            },
            'assignDriver': {
                active: true,
                concierge: togglingConcierge,
            },
            'services': {
                active: true,
                concierge: togglingConcierge,
            },
            'trackOrder': {
                active: true,
                concierge: togglingConcierge,
            },
            'manageRFQ': {
                active: true,
                concierge: togglingConcierge,
            },

            'dashboard': {
                active: true,
                concierge: togglingConcierge,
            }
        },
    },
    auth: {
        concierge: togglingConcierge,
    },

    orders: {
        active: true,
        pages: {
            "create-business-order": {
                active: true,
                concierge: togglingConcierge
            },
            'local-post-order': {
                active: true,
                concierge: togglingConcierge
            },
            'manage-order': {
                active: true,
                concierge: togglingConcierge

            },
            'item-tracking': {
                active: true,
                concierge: togglingConcierge
            },
            'order-tracking': {
                active: true,
                concierge: togglingConcierge
            },
            'manage-internal-post': { // active if concierge=true
                active: true,
                concierge: togglingConcierge

            }


        }
    },


    operations: {
        active: true,
        pages: {
            'dispatch-orders': {
                active: true,
                concierge: togglingConcierge
            },
            'manage-workorders': {
                active: true,
                concierge: togglingConcierge
            },
            'returned-items': {
                active: true,
                concierge: togglingConcierge
            },
            'post-room': { // active if concierge=true
                active: true,
                concierge: togglingConcierge

            }

        }
    },


    finance: {
        active: true,
        pages: {
            'contracts': {
                active: true,
                concierge: togglingConcierge,
                feature:{
                    editContract: true, //postExpress==>true
                    deleteContract: true //postExpress==>true
                },
            },
            managePQ: {
                active: true,
                concierge: togglingConcierge,

                feature: {
                    editPQ: true,
                    localPostBtn:true //postExpress==>true
                }
            },
            'manage-pl': {
                active: true,
                concierge: togglingConcierge,
            },
            'manage-invoice': {
                active: true,
                concierge: togglingConcierge
            }
        }
    },


    reports: {
        active: true,
        concierge: togglingConcierge
    },


    resources: {
        active: true,
        pages: {
            'company': {
                active: true,
                concierge: togglingConcierge,
                feature: {
                    expressLogo: togglingExpress
                }
            },
            'access-control': {
                active: true,
                concierge: togglingConcierge,
                feature: {
                }
            },
            'manage-staff': {
                active: true,
                concierge: togglingConcierge,
                feature: {
                    sector: false
                }
            },
            'manage-drivers': {
                active: true,
                concierge: togglingConcierge,
                feature:{
                    'drive-role': togglingConcierge,
                    'external-branch': togglingConcierge,
              
                }
            },
            'business-accounts': {
                active: true,
                concierge: togglingConcierge
            },
            'manage-couriers': {
                active: true,
            }
        }
    },


    settings: {
        active: true,
        concierge: togglingConcierge,
        pages: {
            'geo-fences': {
                active: true,
                concierge: togglingConcierge,
                feature: {
                }
            },
            'item-return-reason': {
                active: true,

            },
            'mail-item-type': {
                active: true,

            },
            'weight-uom': {
                active: true,
                feature: {
                    edit:false,
                    delete:false
                }
            },
            'length-uom': {
                active: true,

            },
            'manage-department': {
                active: true,

            },
            'manage-driver-role': { // active if concierge=true
                active: togglingConcierge,

            },
            'governorate': {
                active: true,

            },
            'terms-and-conditions': {// active if concierge=true
                active: togglingConcierge,

            },
            'remark': {// active if concierge=true
                active: togglingConcierge,

                feature: {
                    createRemark: togglingConcierge
                }
            },
            'manage-service': {// active if concierge=true
                active: togglingConcierge,

            },
            'manage-packing-packages': {// active if concierge=true
                active: togglingConcierge,


            },
            'country': {
                active: false,


            },
            'area': {
                active: true,


            },
            'business-type': {
                active: false,


            },
            
        }
    },

   

}